import { render } from "./Update.vue?vue&type=template&id=9fa68e4c&scoped=true"
import script from "./Update.vue?vue&type=script&lang=ts"
export * from "./Update.vue?vue&type=script&lang=ts"

import "./Update.vue?vue&type=style&index=0&id=9fa68e4c&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-9fa68e4c"

export default script